import { render, staticRenderFns } from "./screen-5.vue?vue&type=template&id=0c7927d4&scoped=true&"
import script from "./screen-5.vue?vue&type=script&lang=js&"
export * from "./screen-5.vue?vue&type=script&lang=js&"
import style0 from "./screen-5.vue?vue&type=style&index=0&id=0c7927d4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7927d4",
  null
  
)

export default component.exports